import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { ScrollToTop } from './components/ScrollToTop';
import { HomePage } from './pages/HomePage';
import { HowItWorksPage } from './pages/HowItWorksPage';
import { TrustGuaranteesPage } from './pages/TrustGuaranteesPage';
import { ForManufacturers } from './pages/ForManufacturers';
import { ForArchitectsPage } from './pages/ForArchitectsPage';
import { ForOwnersPage } from './pages/ForOwnersPage';
import { ForPhotographersPage } from './pages/ForPhotographersPage';
import { AboutPage } from './pages/AboutPage';
import { FAQPage } from './pages/FAQPage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { ArchitectSubmitPage } from './pages/ArchitectSubmitPage';
import { ArchitectSubmittedPage } from './pages/ArchitectSubmittedPage';
import { ManufacturerRequestPage } from './pages/ManufacturerRequestPage';
import { ManufacturerRequestReceivedPage } from './pages/ManufacturerRequestReceivedPage';
import { OwnerSubmitPage } from './pages/OwnerSubmitPage';
import { OwnerSubmittedPage } from './pages/OwnerSubmittedPage';
import { PhotographerApplyPage } from './pages/PhotographerApplyPage';
import { PhotographerApplicationReceivedPage } from './pages/PhotographerApplicationReceivedPage';
export function App() {
  return <Router data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Layout data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
          <Route path="/how-it-works" element={<HowItWorksPage data-id="element-7" />} data-id="element-6" />
          <Route path="/trust" element={<TrustGuaranteesPage data-id="element-9" />} data-id="element-8" />
          <Route path="/manufacturers" element={<ForManufacturers data-id="element-11" />} data-id="element-10" />
          <Route path="/manufacturers/request" element={<ManufacturerRequestPage data-id="element-13" />} data-id="element-12" />
          <Route path="/manufacturers/request-received" element={<ManufacturerRequestReceivedPage data-id="element-15" />} data-id="element-14" />
          <Route path="/architects" element={<ForArchitectsPage data-id="element-17" />} data-id="element-16" />
          <Route path="/architects/submit" element={<ArchitectSubmitPage data-id="element-19" />} data-id="element-18" />
          <Route path="/architects/project-submitted" element={<ArchitectSubmittedPage data-id="element-21" />} data-id="element-20" />
          <Route path="/owners" element={<ForOwnersPage data-id="element-23" />} data-id="element-22" />
          <Route path="/owners/submit" element={<OwnerSubmitPage data-id="element-25" />} data-id="element-24" />
          <Route path="/owners/property-submitted" element={<OwnerSubmittedPage data-id="element-27" />} data-id="element-26" />
          <Route path="/photographers" element={<ForPhotographersPage data-id="element-29" />} data-id="element-28" />
          <Route path="/photographers/apply" element={<PhotographerApplyPage data-id="element-31" />} data-id="element-30" />
          <Route path="/photographers/application-received" element={<PhotographerApplicationReceivedPage data-id="element-33" />} data-id="element-32" />
          <Route path="/about" element={<AboutPage data-id="element-35" />} data-id="element-34" />
          <Route path="/faq" element={<FAQPage data-id="element-37" />} data-id="element-36" />
          <Route path="/terms" element={<TermsPage data-id="element-39" />} data-id="element-38" />
          <Route path="/privacy" element={<PrivacyPage data-id="element-41" />} data-id="element-40" />
        </Routes>
      </Layout>
    </Router>;
}